// Drives the preset price-range checkboxes (Budget / Nice / Super Nice).
// Multiple tiers can be selected; they're combined into a single min/max
// envelope and written into Shopify's native price gte/lte params, then the
// theme's facets-form-component refreshes the results.
//
// Because Shopify's price filter is one continuous range, selecting
// non-adjacent tiers (e.g. Budget + Super Nice) spans everything in between.

class PriceBucketsComponent extends HTMLElement {
  connectedCallback() {
    this.options = Array.from(this.querySelectorAll('.price-buckets__input'));
    this.gteInput = this.querySelector('[ref="gteInput"]');
    this.lteInput = this.querySelector('[ref="lteInput"]');
    this.status = this.querySelector('.price-buckets__status');

    this.options.forEach((option) => {
      option.addEventListener('change', () => this.onChange());
    });

    // Reflect any active filter (page load / back-forward) into the checkboxes.
    this.syncFromInputs();
  }

  // Lower bound of an option in dollars; '' (Budget) means 0.
  static lower(option) {
    return option.dataset.gte === '' ? 0 : parseFloat(option.dataset.gte);
  }

  // Upper bound of an option in dollars; '' (Super Nice) means open-ended.
  static upper(option) {
    return option.dataset.lte === '' ? Infinity : parseFloat(option.dataset.lte);
  }

  onChange() {
    const checked = this.options.filter((option) => option.checked);

    if (checked.length === 0) {
      this.gteInput.value = '';
      this.lteInput.value = '';
    } else {
      const minLower = Math.min(...checked.map(PriceBucketsComponent.lower));
      const maxUpper = Math.max(...checked.map(PriceBucketsComponent.upper));
      this.gteInput.value = minLower === 0 ? '' : String(minLower);
      this.lteInput.value = maxUpper === Infinity ? '' : String(maxUpper);
    }

    this.updateStatus(checked);
    this.submit();
  }

  // On load, tick every tier fully contained within the active envelope.
  syncFromInputs() {
    const gte = this.gteInput.value === '' ? 0 : parseFloat(this.gteInput.value);
    const lte = this.lteInput.value === '' ? Infinity : parseFloat(this.lteInput.value);

    if (gte === 0 && lte === Infinity) {
      this.updateStatus([]);
      return;
    }

    const checked = [];
    this.options.forEach((option) => {
      const inRange =
        PriceBucketsComponent.lower(option) >= gte && PriceBucketsComponent.upper(option) <= lte;
      option.checked = inRange;
      if (inRange) checked.push(option);
    });
    this.updateStatus(checked);
  }

  updateStatus(checked) {
    if (!this.status) return;
    this.status.textContent = checked.length ? String(checked.length) : '';
    this.status.classList.toggle('bubble', checked.length > 0);
    this.status.classList.toggle('facets__bubble', checked.length > 0);
  }

  submit() {
    const form = this.closest('facets-form-component');
    if (form && typeof form.updateFilters === 'function') form.updateFilters();
  }
}

if (!customElements.get('price-buckets-component')) {
  customElements.define('price-buckets-component', PriceBucketsComponent);
}
